import React from 'react'
import {ThemeProvider, DefaultTheme, StyleSheetManager, StylisPlugin} from 'styled-components'
import rtlPlugin from 'stylis-plugin-rtl'

import {GlobalStyle} from '@miro-site/core'
import {useLocalization} from '@miro-site/localization'

import {theme} from '@miro-site/design-tokens'

interface LegacyLandingPageWrapper {
  children: React.ReactNode
}

/**
 * This wrapper is a temporary solution to support both pages that
 * are built with styled-components/stitches and pages built with bootstrap.
 *
 * This component is exclusively needed for the `lp-builder-pages` app
 * and shouldn't be duplicated/re-used.
 *
 */
const LegacyLandingPageWrapper = ({children}: LegacyLandingPageWrapper): React.ReactElement => {
  const {isRTL} = useLocalization()

  return (
    <ThemeProvider
      theme={
        {
          ...theme,
          multipliers: {
            ...theme.multipliers,
            large: value => `${value}px`,
          },
        } as unknown as DefaultTheme
      }
    >
      <GlobalStyle />
      <StyleSheetManager stylisPlugins={isRTL && [rtlPlugin as unknown as StylisPlugin]}>
        {children}
      </StyleSheetManager>
    </ThemeProvider>
  )
}

export default LegacyLandingPageWrapper
